<template>
  <div class="responsabilitySection" >
    <section v-if="currentSection === section.howTO" class="px-8 my-32">
      <v-row>
        <v-col cols="12">
          <img :src="wardBG" width="100%" class="d-flex" />
          <img :src="wardBG2" width="100%" class="d-flex" />
          <div class="credits mt-8">
            <p><span><b>Curated by:</b></span> Matteo Ward</p>
            <p><span><b>Art and Graphics:</b></span> Sara Guazzarini</p>
            <p><span><b>Content</b></span> WRÅD</p>
          </div>
        </v-col>
      </v-row>
    </section>
    <section v-else-if="currentSection === section.consciuousDesigner" class="px-8 my-32">
      <v-row>
        <v-col
          cols="12"
          md="6"
          :class="[{'even justify-end pr-sm-16': index % 2 === 0}, {'odd justify-start pl-sm-16': index % 2 !== 0}, 'designer d-block d-sm-flex']"
          v-for="(designer, index) in designers"
          :key="designer.id">
          <router-link class="wrapper generic-image-link" :to="{ name: 'Designer', params: { slug: designer._slug, designers } }">
            <seo-v-img
              class="thumbnail"
              cover
              :width=" $vuetify.breakpoint.xsOnly ? '100%' :'400px'"
              :aspect-ratio="0.8"
              :src="`/media/${designer.heroImage.id}`"
              :lazy-src="lazyImgSrc(designer.heroImage)"
              />
            <h2 class="pl-sm-4 mt-2 mt-sm-4 mb-4" v-html="hypenate(designer.name)"></h2>
            <span class="pl-sm-4 ">{{designer[`${$language.current}Nationality`]}}</span>
          </router-link>
        </v-col>
      </v-row>
    </section>
    <DesignersResponsibilityFooter
      v-if="currentSection"
      :responsability-data="responsabilityData"
      :current-section="currentSection"
      :bg="footerBg"
      v-on:catClick="handleCategoryChange"
    />
  </div>
</template>
<script>

import Section from '@/constants/responsabilitySection'
import footerBg from '@/assets/img/resp_awareness_02.png'
import DesignersResponsibilityFooter from '@/molecules/DesignersResponsibilityFooter'
import wardBG from '@/assets/img/matteo_ward.jpg'
import wardBG2 from '@/assets/img/matteo_ward_2.jpg'

export default {
  name: 'DesignersResponsibility',
  components: {
    DesignersResponsibilityFooter
  },
  data () {
    return {
      wardBG,
      wardBG2,
      section: Section,
      footerBg: footerBg
    }
  },
  props: {
    currentSection: {
      type: String,
      default: null
    },
    designers: {
      type: Array,
      default: null
    },
    responsabilityData: {
      type: Object
    }
  },
  methods: {
    hypenate (str) {
      return str.replace(/\u200B/g, '&shy;')
    },
    handleDesignerClick (slug, designers) {
      this.$router.push({ name: 'Designer', params: { slug: slug, designers: designers } })
    },
    handleCategoryChange (target) {
      this.$emit('catClick', target)
    },
    lazyImgSrc (image) {
      const meta = JSON.parse(image.metaData)
      return meta['image-lazy-src']
    }
  }
}
</script>

<style scope lang="scss">
.my-32 {
  margin-top: 128px !important;
  margin-bottom: 128px !important;
}

.designer {
  &:nth-child(even) {
    padding-top: 100px;
    @include breakpoint('xs-only') {
      padding-top: 0;
    }
  }
}

.wrapper {
  max-width: 400px;

  h2 {
    hyphens: auto;
    font-family: $heading-font-family;
    font-size: 3.2rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.1rem;
  }
}
</style>
